
interface Zone {
  id: string;
  name: string;
  loadId: string | null;
}

// Floor plans with zones for each floor
export const floorPlans: Record<number, Zone[]> = {
  1: [ // Ground Floor
    { id: 'gf-reception', name: 'Reception', loadId: '1' },
    { id: 'gf-lobby', name: 'Lobby', loadId: null },
    { id: 'gf-meeting', name: 'Meeting Room A', loadId: '3' },
    { id: 'gf-cafeteria', name: 'Cafeteria', loadId: null },
  ],
  2: [ // First Floor
    { id: 'ff-office', name: 'Open Office', loadId: '5' },
    { id: 'ff-meeting', name: 'Meeting Room B', loadId: '6' },
    { id: 'ff-executive', name: 'Executive Office', loadId: '2' }, 
    { id: 'ff-it', name: 'IT Department', loadId: '7' },
  ],
  3: [ // Second Floor
    { id: 'sf-lab', name: 'Research Lab', loadId: '8' },
    { id: 'sf-dev', name: 'Development', loadId: '9' },
    { id: 'sf-conf', name: 'Conference Room', loadId: null },
    { id: 'sf-server', name: 'Server Room', loadId: '4' },
  ]
};

export type { Zone };
